var _circle, _path, _circle2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStakeholder360(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-stakeholder360"
  }, "Stakeholder360") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-stakeholder360"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9,
    r: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19c0-2.6 1.9-4.4 4-4.4s4 1.8 4 4.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 9,
    r: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19c0-2.6 1.9-4.4 4-4.4s4 1.8 4 4.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9h0.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h0.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholder360);
export default __webpack_public_path__ + "static/media/stakeholder360.fd707fbd4f713f257e51cb8b30438c3d.svg";
export { ForwardRef as ReactComponent };